import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { PluckingChecklistBPLTeaReport } from './Pages/listing';

export const PluckingChecklistBPLTeaReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={PluckingChecklistBPLTeaReport} />
    </Fragment>
)